import gql from "graphql-tag";

const localBookCoreFragment = gql`
  fragment LocalBookCore on LocalBook {
    id
    _id
    title
    slug
    price
    isbn
    thumbnailUrl
    imageUrl
    description
    vatIncluded
    currency {
      id
      _id
    }
    format {
      id
      _id
      mimeType
      schemaOrgUrl
    }
  }
`;

const localBookDetailsFragment = gql`
  fragment LocalBookDetails on LocalBook {
    ...LocalBookCore
    available
    publishedOn
    language
    publisher {
      id
      _id
      name
      slug
      description
    }
    bookAuthors {
      id
      _id
      sequence
      author {
        id
        _id
        name
        bio
      }
      role {
        id
        _id
        description
      }
    }
    subjects(first: 20) {
      edges {
        node {
          id
          _id
          heading
          code
          subjectScheme {
            id
            heading
          }
        }
      }
    }
    encryptedFile {
      id
      _id
      filePath
    }
    availableFrom
    createdAt
    updatedAt
  }
  ${localBookCoreFragment}
`;

const localBookAdminListFragment = gql`
  fragment LocalBookAdminList on LocalBook {
    id
    _id
    title
    slug
    price
    isbn
    thumbnailUrl
    imageUrl
    description
    vatIncluded
    available
    availableFrom
    publishedOn
    language
    createdAt
    currency {
      id
      _id
    }
    format {
      id
      _id
      mimeType
      schemaOrgUrl
    }
    publisher {
      id
      _id
      name
    }
    bookAuthors {
      id
      _id
      sequence
      author {
        id
        _id
        name
      }
      role {
        id
        _id
        description
      }
    }
  }
`;

const localBookSearchResultFragment = gql`
  fragment LocalBookSearchResult on LocalBook {
    id
    _id
    title
    slug
    thumbnailUrl
    imageUrl
  }
`;

export default {
  localBookCoreFragment,
  localBookDetailsFragment,
  localBookAdminListFragment,
  localBookSearchResultFragment,
};
